import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-budget-request-details',
  templateUrl: './budget-request-details.component.html',
  styleUrls: ['./budget-request-details.component.scss']
})
export class BudgetRequestDetailsComponent implements OnInit {

  products: Product[];
  items: MenuItem[];
  displayBasic: boolean;
  displayBasic2: boolean;

  constructor(private productService: ProductService) { }

  ngOnInit() {
    this.productService.getProductsSmall().then(data => this.products = data);
    this.items = [
      {label: 'Menu'},
      {label: 'Menu Active'},
  ];
}

showBasicDialog() {
  this.displayBasic = true;
}

showBasicDialog2() {
  this.displayBasic2 = true;
}

}
